import { render } from "./Burn.vue?vue&type=template&id=40710182&scoped=true"
import script from "./Burn.vue?vue&type=script&lang=js"
export * from "./Burn.vue?vue&type=script&lang=js"

import "./Burn.vue?vue&type=style&index=0&id=40710182&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40710182"]])

export default __exports__